
  import React from "react"
  import Component from "/codebuild/output/src694322608/src/pedro-site/src/layouts/index.js"
  import data from "/codebuild/output/src694322608/src/pedro-site/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js